// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.svg-icon[data-v-4818b1bc] {\n  width: 1em;\n  height: 1em;\n  vertical-align: -0.15em;\n  fill: currentColor;\n  overflow: hidden;\n}\n.svg-external-icon[data-v-4818b1bc] {\n  background-color: currentColor;\n  -webkit-mask-size: cover !important;\n          mask-size: cover !important;\n  display: inline-block;\n}\n", ""]);
// Exports
module.exports = exports;
